
(function () {
  'use strict';

  if (window.__wcTierPrice) return;
  window.__wcTierPrice = true;

  var EVENT_NAME = (window.WCTier && window.WCTier.EVENT_NAME) || 'wc:tier-updated';

  
  function fmtCents(cents) {
    var d = Math.floor(cents / 100), c = cents % 100;
    var html = '<span class="wc-price-sym">$</span>' + d.toLocaleString('en-US');
    if (c === 0) return html;
    return html + '<span class="wc-price-cents">.' + (c < 10 ? '0' : '') + c + '</span>';
  }

  
  function clearStrikes() {
    document.querySelectorAll('.wc-tier-compare').forEach(function (s) {
      var sp = s.nextSibling;
      if (sp && sp.nodeType === 3 && !sp.textContent.trim()) sp.remove();
      s.remove();
    });
  }

  

  var observeNodes = [];
  (function () {
    var r = document.querySelector('.wc-price-row');
    var pw = r ? r.querySelector('[id^="price-"]') : null;
    if (pw) observeNodes.push(pw);
    var sp = document.querySelector('.sticky-atc-bar__price');
    if (sp) observeNodes.push(sp);
  })();
  var observer = observeNodes.length
    ? new MutationObserver(function () {
        var s = window.WCTier && window.WCTier.getState ? window.WCTier.getState() : null;
        if (s) paint(s);
      })
    : null;
  function armObserver() {
    if (!observer) return;
    observeNodes.forEach(function (n) {
      observer.observe(n, { childList: true, subtree: true });
    });
  }

  function paint(state) {
    var off = (state && state.off) || 0;
    if (observer) observer.disconnect();

    clearStrikes();
    document.querySelectorAll('.wc-tier-pct').forEach(function (p) { p.remove(); });

    document.querySelectorAll('[data-wc-base-cents]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-wc-base-cents'), 10) || 0;
      if (!base) return;
      
      var shown = off > 0 ? base - Math.floor(base * off / 100) : base;
      var html = fmtCents(shown);
      if (el.innerHTML !== html) el.innerHTML = html;
      el.classList.toggle('wc-tier-discounted', off > 0);

      
      if (off > 0 && el.parentNode) {
        var root = el.closest('.price');
        var native = root && (
          root.classList.contains('price--on-sale') ||
          root.classList.contains('volume-pricing--sale-badge')
        );
        if (!native && root) {
          var s = document.createElement('s');
          s.className = 'price-item price-item--regular wc-tier-compare';
          s.innerHTML = fmtCents(base);
          el.parentNode.insertBefore(s, el);
        }
      }

      
      if (off > 0 && el.parentNode &&
          (el.closest('.card-information') || el.closest('.wc-price-row') ||
           el.closest('.sticky-atc-bar'))) {
        var pct = document.createElement('span');
        pct.className = 'wc-tier-pct';
        pct.textContent = '-' + off + '%';
        el.parentNode.insertBefore(pct, el.nextSibling);
      }
    });

    var badge = document.querySelector('.wc-b3g3f-badge');
    if (badge) {

      badge.textContent = (badge.dataset && badge.dataset.wcBadgeDefault) || 'BUY 6, SAVE 50%';
      badge.hidden = off > 0;
    }

    armObserver();
  }

  document.addEventListener(EVENT_NAME, function (e) { paint(e.detail); });

  
  
  armObserver();
  var s0 = window.WCTier && window.WCTier.getState ? window.WCTier.getState() : null;
  if (s0) paint(s0);
})();
